/* eslint-disable no-undef, new-cap */
const CONTACT_FORM_RECAPTCHA_LOG = '[ContactFormRecaptcha]';

var jsonData;
var $postalCode = $('[name = "POSTAL_CODE"], [name = "Postal_Code__c"]');
var $country = $('[name = "COUNTRY"],[name = "Country2__c"]');
var $city = $('[name = "CITY"],[name = "City__c"]');

$(document).ready(function () {

    $postalCode.attr('readonly', 'readonly');
    $city.attr('readonly', 'readonly');

    $country.change(function() {
        if ($country.val() == '') {
            $postalCode.attr('readonly', 'readonly');
            $city.attr('readonly', 'readonly');
        }
 else {
            $postalCode.removeAttr('readonly');
            $city.removeAttr('readonly');
        }
    });

    $postalCode.keyup(function () {
        var country = $country.val();
        var postalCode = $postalCode.val();
        try {
            var url = 'https://wpwsc.egoncloud.com:1252/Egon/EgonLstJSON?LST=LstZip&CDXZIP=' + postalCode;
            jsonData = jQuery.parseJSON(httpGet(url + '&MAXLIVLOC=8&TPXEXT=L&USER=WPTC04LCA01&PASW=Y0YGKFKH&WPXISO=' + country));
            if (jsonData.LSTERR.DSXERR == 'Ok') {
                //jsonData.ZIP_AREA_OUT.ZIP[x].DSXOBJDPT -->> PROVINCIA
                //jsonData.ZIP_AREA_OUT.ZIP[x].DSXOBJCNL -->> CIUDAD/POBLACI�N
                //jsonData.ZIP_AREA_OUT.ZIP[x].DSXOBJDS1 -->> DISTRITO

                if (jsonData.ZIP_AREA_OUT.ZIP.length >= 1) {
                    $city.val(jsonData.ZIP_AREA_OUT.ZIP[0].DSXOBJCNL);
                }
                if (jsonData.ZIP_AREA_OUT.ZIP.length == 1) {
                    $city.val(jsonData.ZIP_AREA_OUT.ZIP[0].DSXOBJCNL);
                }

            }
        }
 catch (error) {
            console.log(CONTACT_FORM_RECAPTCHA_LOG, 'Error trying to access EgonCloud services: ' + error); // eslint-disable-line no-console
        }

    });

    $city.keyup(function () {
        var country = $country.val();
        var city = $city.val();
        try {
            var url = 'https://wpwsc.egoncloud.com:1252/Egon/EgonLstJSON?LST=LstCnl&DSXCNL=' + city;
            jsonData = jQuery.parseJSON(httpGet(url + '&MAXLIVLOC=8&TPXEXT=L&USER=WPTC04LCA01&PASW=Y0YGKFKH&WPXISO=' + country));
            var tam = jsonData.CNL_AREA_OUT.CNL.length;
            var options = new Array(tam - 1);
            for (let i = 0; i < tam; i++) {
                options[i] = jsonData.CNL_AREA_OUT.CNL[i].DSXOBJCNL;
            }

            $city.autocomplete({ source: options });
        }
 catch (error) {
            console.log(CONTACT_FORM_RECAPTCHA_LOG, 'Error trying to access EgonCloud services: ' + error);// eslint-disable-line no-console
        }
    });

    $city.change(function () {
        var country = $country.val();
        var city = $city.val();
        try {
            var url = 'https://wpwsc.egoncloud.com:1252/Egon/EgonLstJSON?LST=LstCnl&DSXCNL=' + city;
            jsonData = jQuery.parseJSON(httpGet(url + '&MAXLIVLOC=8&TPXEXT=L&USER=WPTC04LCA01&PASW=Y0YGKFKH&WPXISO=' + country));
            if (jsonData.CNL_AREA_OUT.CNL.length >= 1 && $('[name = "CITY"]').val() != '') {
                $postalCode.val(jsonData.CNL_AREA_OUT.CNL[0].CDXZIP);
            }
        }
 catch (error) {
            console.log(CONTACT_FORM_RECAPTCHA_LOG, 'Error trying to access EgonCloud services: ' + error);// eslint-disable-line no-console
        }
    });

    function httpGet(theUrl) {
        var xmlHttp = new XMLHttpRequest();
        xmlHttp.open('GET', theUrl, true); // false for synchronous request
        xmlHttp.send(null);
        return xmlHttp.responseText;
    }

    // filling country dropdown list with all the countries
    function saveCountry(item) {
        $country.append(`<option value="${item.threeLetterIsoCode}"> ${item.name} </option>`);
    }

    function getCountryCode(country) {
        for (var i=0;  i < CountryList().get().length; i++) {
            if (CountryList().get()[i].name.toLowerCase() == country.toLowerCase()) {
                return CountryList().get()[i].threeLetterIsoCode;
            }
        }
    }

    CountryList().get().forEach(saveCountry);
    let queryString = new QueryStringProcessor().getUrlParams();
    if (queryString.country) {
        var countryCode = getCountryCode(queryString.country);
        //$('[name="COUNTRY"] option[text="'+queryString.country+'"]').attr("selected", true);
        $('[name="COUNTRY"],[name="Country_c"] option[value="'+countryCode+'"]').attr('selected', true);


    }


    // We didn't find the way of managing option IDs from SF back-end so we set them in order from 0 to 6
    // initial 'select a contact type' option plus 6 options. They should be in the correct order in SF back-end
    var predIndex = 0;
    $('[name="RELATION_TYPE"] option').each(function () {
        $(this).val(predIndex);
        predIndex = predIndex + 1;
    });

    // create hidden field inside contact form with site_name (taken from the meta property fields in html's head)
    // it is needed inside the form when submitting to SF backEnd
    var inputSiteName = jQuery('<input type="hidden" name="SITE_NAME">');
    $('.mi-contact-form').find('form').append(inputSiteName);
    var contactUri = encodeURI(document.querySelector('meta[property=\'og:site_name\']').getAttribute('content'));
    $('[name="SITE_NAME"]').val(contactUri);

    // adding
    //  - reCaptcha validation
    //  - Pardot FORM request to SF
    // to submit button click event (it is executed before submit event)
    $('#mi-contact-form-email').on('click', function (event) {
        var selectedContactType = $('[name="RELATION_TYPE"] option:selected').val();
        var recaptchaBox = $(this).parentsUntil('#mi-corpo-contact-form-custom-email-submit').parent();
        if (recaptchaBox.find('input[name=\'completed_captcha\']').val() != 'valid') {
            recaptchaBox.find('#mi-corpo-contact-form-download-invalid-recaptcha').show();
            event.preventDefault();
            event.stopPropagation();
            return false;
        }
 else {
            if (selectedContactType == 1 || selectedContactType == 6) {
                $.post('/register-form-action',
                    {
                        NAME: $('[name="NAME"]').val(),
                        COMPANY_NAME: $('[name="COMPANY_NAME"]').val(),
                        FIRST_NAME: $('[name="FIRST_NAME"]').val(),
                        EMAIL: $('[name="EMAIL"]').val(),
                        RELATION_TYPE: $('[name="RELATION_TYPE"]').val(),
                        POSTAL_CODE: $postalCode.val(),
                        COUNTRY: $country.val(),
                        TELEPHONE: $('[name="TELEPHONE"]').val(),
                        SITE_NAME: document.querySelector('meta[property=\'og:site_name\']').getAttribute('content')
                    });
            }
        }

        recaptchaBox.find('#mi-corpo-contact-form-download-invalid-recaptcha').hide();
    });

    $('[name="RELATION_TYPE"]').on('change', function () {

        var selectedContactType = $('[name="RELATION_TYPE"] option:selected').val();
        var currentSite = $('meta[property="og:site_name"]').attr('content');
        var contactFormSfUri = $('#mi-corpo-contact-form-ajax-submit-url').val();
        var listOfActiveSites = $('#mi-corpo-contact-form-pardot_active_sites').val().split(';');
        var contactFormPardotUri = $('#mi-corpo-contact-form-pardot_uri').val();

        if (listOfActiveSites.includes(currentSite)) {
            if (selectedContactType == 1 || selectedContactType == 6) {
                // hide attachment
                $('.sf-FileField.form-group').hide();
                // change submit URI
                $('.mi-contact-form').find('form').attr('action', contactFormPardotUri);
                $('.mi-contact-form').find('form').removeAttr('enctype');

            }
 else {
                $('.sf-FileField.form-group').show();
                // change submit URI
                $('.mi-contact-form').find('form').attr('action', contactFormSfUri);
                $('.mi-contact-form').find('form').attr('enctype', 'multipart/form-data');
            }
        }
 else {
            // do normal action
            $('.sf-FileField.form-group').show();
            // TODO change submit URI
            $('.mi-contact-form').find('form').attr('action', contactFormSfUri);
            $('.mi-contact-form').find('form').attr('enctype', 'multipart/form-data');
        }
    });

    $('button[data-sf-btn-role="next"]').on('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        var currentWidth = $('.progress-bar').width() / $('.progress-bar').parent().width() * 100;

        setTimeout(function () {
            //if (!event.currentTarget.form[1].value) {
            if (event.currentTarget.form[1].value.length <= 35) {
                $('.progress-bar').width((currentWidth + 50) + '%');
                }
            },
            50
        );

    });

    $('#mi-contact-form-email-reset-button').on('click', function () {
        $('input').each(function (index, element) {
            $(element).val('').trigger('change');
        });

        $('select').each(function (index, element) {
            $(element).val('').trigger('change');
        });

        $('textarea').each(function (index, element) {
            $(element).val('').trigger('change');
        });


    });

    $('a[data-sf-btn-role="prev"]').on('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        var currentWidth = $('.progress-bar').width() / $('.progress-bar').parent().width() * 100;

        setTimeout(function() {
            $('.progress-bar').width((currentWidth - 50) + '%');
            },
            50
        );

        event.preventDefault();
    });

    $('#HiddenField-1').prop('type','reset').val('Reset').trigger('change');
    $('#HiddenField-2').prop('type','reset').val('Reset').trigger('change');
    $('#HiddenField-3').prop('type','reset').val('Reset').trigger('change');

    $('#HiddenField-1').on('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
        var $inputs = $('.mi-contact-form div[data-sf-role="separator"][style=""] input[type!="reset"]');
        var $selects = $('.mi-contact-form div[data-sf-role="separator"][style=""] select');
        var $textareas = $('.mi-contact-form div[data-sf-role="separator"][style=""] textarea');
        $inputs.add($selects).add($textareas).val('').trigger('change');
    });

    $('#HiddenField-2').on('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
        var $inputs = $('.mi-contact-form div[data-sf-role="separator"][style=""] input[type!="reset"]');
        var $selects = $('.mi-contact-form div[data-sf-role="separator"][style=""] select');
        var $textareas = $('.mi-contact-form div[data-sf-role="separator"][style=""] textarea');
        $inputs.add($selects).add($textareas).val('').trigger('change');
    });

    $('#HiddenField-3').on('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
        $('#mi-contact-form-email').removeAttr('disabled');
        var $inputs = $('.mi-contact-form div[data-sf-role="separator"][style=""] input[type!="reset"]');
        var $selects = $('.mi-contact-form div[data-sf-role="separator"][style=""] select');
        var $textareas = $('.mi-contact-form div[data-sf-role="separator"][style=""] textarea');
        $inputs.add($selects).add($textareas).val('').trigger('change');
    });

    $('input[type="text"], textarea').on('blur change', function (e) {
        var $this = $(this); var val = $this.val(); if (val.trim() === val) {
 e.preventDefault(); return false;
}
        else {
 $this.val(val.trim()); $this.change();
}
    });
});
